import React from "react";

import { ChevronDoubleRightIcon } from "@heroicons/react/outline";

import HeroSection from "./hero-section";
import { sendAnalyticEvent } from "./layout/page/use-page";

type Props = { url: string; buttonText: string; description: string };

const NextSectionAction = ({ url, buttonText, description }: Props) => (
  <div className="bg-primary z-20 relative">
    <HeroSection className="sm:py-12 lg:py-16">
      <HeroSection.Content>
        <div className="flex flex-wrap items-center justify-center -mx-2 -my-2">
          <div className="text-white text-base md:text-lg mx-2 my-2">{description}</div>
          <a
            href={url}
            className="btn btn-dark text-sm md:text-base flex items-center mx-2 my-2"
            onClick={() => sendAnalyticEvent("Engagement Button", "Buttons", `Next Page ${buttonText}`)}
          >
            <span>{buttonText}</span>
            <ChevronDoubleRightIcon className="h-4 w-4 ml-2" />
          </a>
        </div>
      </HeroSection.Content>
    </HeroSection>
  </div>
);

export default NextSectionAction;
